import React, { useState, useEffect, useMemo } from "react";
import { Drawer } from "flowbite-react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import HandleAttendance from "../header/components/handleAttendance";
import { _userRole } from "../../../../utils/common";
import useUserRole from "../../../../hooks/useUserRole";
import logo from "../../../assets/images/1024_1024.png";
import { IoMdArrowDropdown, IoMdArrowDropup, } from "react-icons/io";
import {
  getLongestMatchingSubPath,
  pathMatchesRoute,
} from "../sidebar/menuPathUtils";
export function MenuDrawer({
  isOpen,
  handleClose,
  menu = [],
  settingmenu = [],
}) {
  const { loading } = useSelector((state) => state.user);
  const role = useUserRole();

  return (
    <div className="flex flex-col gap-2">
      <Drawer
        open={isOpen}
        onClose={handleClose}
        position="right"
        className="p-0"
      >
        <div className="flex flex-col overflow-y-auto h-[calc(100vh-86px)] text-theme">
          <div className="p-4 border-b border-gray-200 h-20 flex items-center text-md">
            <img src={logo} alt={`logo`} className="w-10 h-10" />
          </div>
          <div className="px-4 pt-4 border-priamry-100 flex justify-end w-full">
            {role === _userRole.STAFF ? <HandleAttendance /> : null}
          </div>
          <div className="flex flex-col p-4 overflow-y-auto scrollbar-hidden border-b min-h-48 text-theme">
            <div className="flex flex-col gap-2">
              {loading ? (
                Array(10)
                  .fill(null)
                  ?.map((item) => {
                    return <MenuLoading />;
                  })
              ) : (
                <div>
                  {
                    <div className="flex flex-col gap-2">
                      {menu?.length &&
                        menu?.map((item, index) => (
                          <Menu
                            type={item.type}
                            key={index}
                            icon={item.icon}
                            path={item.path}
                            label={item.label}
                            subMenu={item.subMenu}
                            handleClose={handleClose} // ✅ pass it here
                          />
                        ))}
                    </div>
                  }
                </div>
              )}
            </div>
          </div>
          <div className={"flex flex-col gap-1 px-4 border-b py-4 scrollbar-hidden"}>
            <div className="flex flex-col gap-2">
              {loading
                ? settingmenu?.map((_, index) => <MenuLoading key={index} />)
                : settingmenu?.map((item, index) => (
                    <Menu
                      type={item.type}
                      key={index}
                      icon={item.icon}
                      path={item.path}
                      label={item.label}
                      subMenu={item.subMenu}
                      handleClose={handleClose}
                    />
                  ))}
            </div>
          </div>
        </div>

        <div className={"flex font-light flex-col gap-3 p-4"}>
          <div className="text-[12px] text-theme">
            <p>Terms of Services</p>
            <p>Privacy Policy</p>
            <span className="text-primary-400">Copyright © 2022 bydo.io</span>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

// const Menu = ({ icon, path, label, handleClose, type }) => {
//   const location = useLocation();
//   const isActive =
//     path === "/"
//       ? location.pathname === "/"
//       : location.pathname.startsWith(path);

//   const activeClasses = "!bg-gray-100 hover:bg-gray-200 !text-theme";
//   const inactiveClasses = "text-theme hover:bg-gray-50";

//   return (
//     <Link
//       to={path}
//       onClick={handleClose}
//       className={`text-md flex items-center gap-4 h-8 px-2 rounded-md font-medium ${
//         isActive ? activeClasses : inactiveClasses
//       }`}
//     >
//       {/* <img src={icon} alt="icon" className="w-5 h-5" /> */}
//       {type === "icon" ? (
//         icon
//       ) : (
//         <img src={icon} alt={`${label} icon`} className="w-6 h-6" />
//       )}
//       <span className="text-sm">{label}</span>
//     </Link>
//   );
// };

const Menu = ({ icon, path, label, handleClose, type, subMenu = [] }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const activeSubPath = useMemo(
    () => (subMenu?.length ? getLongestMatchingSubPath(subMenu, location.pathname) : null),
    [subMenu, location.pathname]
  );

  const hasRouteInSubmenu = Boolean(activeSubPath);

  useEffect(() => {
    if (subMenu?.length) {
      setOpen(hasRouteInSubmenu);
    }
  }, [location.pathname, hasRouteInSubmenu, subMenu?.length]);

  const isActive = subMenu?.length
    ? hasRouteInSubmenu
    : path === "/"
      ? location.pathname === "/"
      : path && pathMatchesRoute(location.pathname, path);

  const activeClasses = "!bg-gray-100 hover:bg-gray-200 !text-theme";
  const inactiveClasses = "text-theme hover:bg-gray-50";

  const toggleSubmenu = (e) => {
    // prevent parent link navigation if submenu exists
    if (subMenu?.length) {
      e.preventDefault();
      setOpen((prev) => !prev);
    } else {
      handleClose?.();
    }
  };

  return (
    <div className="flex flex-col ">
      <Link
        to={subMenu?.length ? "#" : path}
        onClick={toggleSubmenu}
        className={`text-md flex items-center justify-between gap-2 py-1 px-2 rounded-md font-medium ${
          isActive ? activeClasses : inactiveClasses
        }`}
      >
        <div className="flex items-center gap-3">
          {type === "icon" ? (
            icon
          ) : (
            <img src={icon} alt={`${label} icon`} className="w-6 h-6" />
          )}
          <span className="text-cs font-semibold">{label}</span>
        </div>

        {/* show arrow if submenu exists */}
        {subMenu?.length > 0 &&
          (open ? (
            <IoMdArrowDropup  className="text-lg" />
          ) : (
            <IoMdArrowDropdown className="text-lg" />
          ))}
      </Link>

      {/* Submenu items */}
      {open && subMenu?.length > 0 && (
        <div className="ml-8 mt-1 flex flex-col gap-1 text-theme">
          {subMenu.map((sub, idx) =>
            sub.isGroupTitle ? (
              <div
                key={idx}
                className="text-xs font-semibold text-theme/80 uppercase mt-2"
              >
                {sub.label}
              </div>
            ) : (
              <Link
                key={idx}
                to={sub.path}
                onClick={handleClose}
                className={`text-sm px-2 py-1 rounded hover:bg-gray-100 ${
                  sub.path && activeSubPath && sub.path === activeSubPath
                    ? "text-theme font-semibold bg-gray-100"
                    : "text-theme/80"
                }`}
              >
                {sub.label}
              </Link>
            )
          )}
        </div>
      )}
    </div>
  );
};
const MenuLoading = () => (
  <div className="flex items-center gap-1 h-8 px-2 rounded-md animate-pulse">
    <div className="h-4 bg-light dark:bg-textLight w-6 rounded-md"></div>
    <div className="h-4 bg-light dark:bg-textLight w-full rounded-md"></div>
  </div>
);
